"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("../util");

var inline = {
  inline: {
    padding: function padding(_a) {
      var padd = _a.padd,
          size = _a.size;
      return padd ? "\n          " + size / 4 * util_1.getScalar(padd) + "px\n          " + size / 2 * util_1.getScalar(padd) + "px\n        " : undefined;
    }
  },
  //prettier-ignore
  styles: util_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-flex;\n\n    border: ", ";\n\n    ", "\n  "], ["\n    display: inline-flex;\n\n    border: ", ";\n\n    ", "\n  "])), function (_a) {
    var border = _a.border,
        borderColor = _a.borderColor;
    if (border) return "1px solid " + borderColor.bq;else return 'none';
  }, function (_a) {
    var gutter = _a.gutter,
        column = _a.column,
        size = _a.size;
    return gutter && "\n\t\t\t> :not(:first-child) {\n        margin-" + (column ? 'top' : 'left') + ":" + util_1.round(size / 8 * util_1.getScalar(gutter)) + "px;\n      }\n      > :not(:last-child) {\n        margin-" + (column ? 'bottom' : 'right') + ":" + util_1.round(size / 8 * util_1.getScalar(gutter)) + "px;\n      }\n    ";
  }),
  props: {
    bg: {
      default: true
    },
    rounded: {
      default: true
    }
  }
};
exports.default = inline;
var templateObject_1;